import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';

const failureIcon = require('./failure.svg') as string;

export interface IDealRentFailureModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const DealRentFailureModal = ({ isOpen, closeModal }: IDealRentFailureModalProps) => {
  return (
    <ModalWindow
      onClose={closeModal}
      open={isOpen}
      content={
        <div className={styles['container']}>
          <img src={failureIcon} />
          <h1 className={styles['title']}>Вы уже отправляли анкету по этому объявлению</h1>
          <div className={styles['text']}>Вам придёт СМС с ответом собственника</div>
          <Button size="XS" onClick={closeModal}>
            Хорошо
          </Button>
        </div>
      }
    />
  );
};
